import { Modal } from 'react-bootstrap'
import styled from 'styled-components'

export const StyledConfirmModal = styled(Modal)`
  .modal-content {
    width: 120%;
  }
  .modal-body {
    padding: 2rem !important;
  }
  .recall-dialog-container {
    margin: auto;
    /* border: 1px solid #888; */
    width: 600px;
    height: auto;
  }
  .recall-dialog-title {
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    background-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
    width: 100%;
    font-size: 21px !important;
    height: auto;
    max-height: 80px;
    position: relative !important;
  }
  .recall-dialog-title-icon {
    height: 35px;
    transform: translateX(6px) translateY(-2px) scale(0.8);
  }
  .recall-dialog-content {
    height: auto;
    width: 597px;
    overflow-y: auto;
    margin-bottom: 5px;
    max-height: 450px;
    font-size: 16px;
  }
  .recall-dialog-content div {
    margin: 0;
    padding: 15px 0 0 0;
    text-align: justify;
  }
  .recall-dialog-content-class div p {
    margin: 0;
    padding: 5px 0 0 0;
  }
  .recall-dialog-content::-webkit-scrollbar {
    width: 8px;
  }
  .recall-dialog-content::-webkit-scrollbar-thumb {
    background: grey;
    border-radius: 10px;
  }
  .recall-dialog-content::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  .recall-dialog-content::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  .recall-dialog-title-text {
    color: white;
    width: 95%;
    word-break: break-word;
    padding: 10px 0px 0px 10px;
    text-align: center;
    border: none;
    max-height: 400px;
    font-size: 17px;
  }
  .recall-dialog-acknowledge-button {
    margin-top: 10px;
    padding: 20px 28px;
    color: white;
    outline: none;
    background-color: black;
    border: none;
    text-transform: uppercase;
    border-radius: 3px;
    line-height: 1;
    display: block;
    font-size: 14px;
  }

  .recall-dialog-acknowledge-button:hover {
    background-color: #666;
    color: #fff;
  }
  .recall-dialog-close-button {
    padding: 0 !important;
    color: white !important;
    float: right;
    line-height: 1;
    display: block;
    transform: translateY(2px);
  }
  /*.recall-dialog-close-button:hover,
.recall-dialog-close-button:focus {
    color: #b3b3b3;
    text-decoration: none;
    cursor: pointer;
}*/
  .recall-dialog-title-icon {
    height: 35px;
    margin-right: 6px;
  }

  .m-0 {
    margin: 0px;
  }

  .p-0 {
    padding: 0px;
  }

  .p-1 {
    padding: 10px;
  }
`
